// バリデーションメッセージ
import React from 'react';
var ValidMessage = function (_a) {
    var message = _a.message;
    return (React.createElement(React.Fragment, null, message && (React.createElement("span", { className: "is-invalid" },
        React.createElement("strong", null, message)))));
};
export default ValidMessage;
